import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import { CrashTable } from '@/components/features/crashes';

export function CrashesPage() {
  return (
    <>
      <Meta title="Crashes" />

      <Container className="space-y-6">
        <p className="text-[12.5px] text-muted-foreground">
          Grouped by crash signature: one row can span many machines. Open a row for its newest
          reports, or raise an issue from it.
        </p>
        <CrashTable />
      </Container>
    </>
  );
}
